import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import axios from 'axios';
import Footer from '@/components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AboutPage = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState({ title: 'Quem Somos', content: '' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/content/about_us`);
      setContent(response.data);
    } catch (error) {
      console.error('Failed to fetch content');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F8] flex flex-col">
      <header className="bg-white border-b border-[#E4E4E7]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">{content.title}</h1>
        </div>
      </header>

      <main className="flex-1 max-w-4xl mx-auto px-6 py-8 w-full">
        {loading ? (
          <div className="text-center py-12">Carregando...</div>
        ) : (
          <div className="bg-white border border-[#E4E4E7] rounded-md p-8">
            <div className="prose max-w-none break-words">
              {content.content.split('\n').map((paragraph, index) => (
                <p key={index} className="mb-4 text-[#4B4C52] break-words whitespace-pre-wrap">{paragraph}</p>
              ))}
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default AboutPage;